module.exports = __webpack_public_path__ + "static/media/Star.49c0512f.svg";